/**
 * @generated SignedSource<<be08d86f0391812f3fa3a4ca9cae3f57>>
 * @relayHash 444de2e3bd553d455e56a1c83ac051a8
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 444de2e3bd553d455e56a1c83ac051a8

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type IssueClosedStateReason = "COMPLETED" | "NOT_PLANNED" | "%future added value";
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type UpdateIssuesBulkByQueryInput = {
  addToProjectV2Ids?: ReadonlyArray<string> | null;
  applyAssigneeIds?: ReadonlyArray<string> | null;
  applyLabelIds?: ReadonlyArray<string> | null;
  clearMilestone?: boolean | null;
  clientMutationId?: string | null;
  issueTypeId?: string | null;
  milestoneId?: string | null;
  query: string;
  removeAssigneeIds?: ReadonlyArray<string> | null;
  removeLabelIds?: ReadonlyArray<string> | null;
  repositoryId: string;
  state?: IssueState | null;
  stateReason?: IssueClosedStateReason | null;
  unsetIssueType?: boolean | null;
};
export type updateIssueAssigneesBulkByQueryMutation$variables = {
  input: UpdateIssuesBulkByQueryInput;
};
export type updateIssueAssigneesBulkByQueryMutation$data = {
  readonly updateIssuesBulkByQuery: {
    readonly jobId: string | null;
  } | null;
};
export type updateIssueAssigneesBulkByQueryMutation$rawResponse = {
  readonly updateIssuesBulkByQuery: {
    readonly jobId: string | null;
  } | null;
};
export type updateIssueAssigneesBulkByQueryMutation = {
  rawResponse: updateIssueAssigneesBulkByQueryMutation$rawResponse;
  response: updateIssueAssigneesBulkByQueryMutation$data;
  variables: updateIssueAssigneesBulkByQueryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateIssuesBulkByQueryPayload",
    "kind": "LinkedField",
    "name": "updateIssuesBulkByQuery",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jobId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateIssueAssigneesBulkByQueryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateIssueAssigneesBulkByQueryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "444de2e3bd553d455e56a1c83ac051a8",
    "metadata": {},
    "name": "updateIssueAssigneesBulkByQueryMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f7a9c293e5cc80562b7a7c7fe81ed937";

export default node;
